"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bytes = void 0;
/* tslint:disable:no-bitwise number-literal-format */
var StringDecoder = require('string_decoder').StringDecoder;
var Bytes = /** @class */ (function () {
    function Bytes() {
    }
    Bytes.ensureCapacity = function (numbers, minLength, padding) {
        var array = numbers.length < minLength
            ? __spread(new Array(numbers), new Array(minLength + padding - numbers.length).fill(0)) : numbers;
        return new Int8Array(array);
    };
    Bytes.intToByteArray2 = function (int32) {
        return __awaiter(this, void 0, void 0, function () {
            var byteArray, b;
            return __generator(this, function (_a) {
                byteArray = [];
                for (b = 16; b < 32; b += 8) {
                    byteArray.push((int32 >>> (24 - (b % 32))) & 0xff);
                }
                return [2 /*return*/, new Int8Array(byteArray)];
            });
        });
    };
    Bytes.intToByteArray3 = function (int32) {
        return __awaiter(this, void 0, void 0, function () {
            var byteArray, b;
            return __generator(this, function (_a) {
                byteArray = [];
                for (b = 8; b < 32; b += 8) {
                    byteArray.push((int32 >>> (24 - (b % 32))) & 0xff);
                }
                return [2 /*return*/, new Int8Array(byteArray)];
            });
        });
    };
    Bytes.intToByteArray = function (int32) {
        return __awaiter(this, void 0, void 0, function () {
            var byteArray, b;
            return __generator(this, function (_a) {
                byteArray = [];
                for (b = 0; b < 32; b += 8) {
                    byteArray.push((int32 >>> (24 - (b % 32))) & 0xff);
                }
                return [2 /*return*/, new Int8Array(byteArray)];
            });
        });
    };
    Bytes.syncIntFromByteArray = function (bytes) {
        var e_1, _a;
        /*
        const a = new Int32Array(bytes.buffer);
        return Number(a[0]);
        */
        var value = 0;
        var ubytes = new Uint8Array(bytes);
        try {
            for (var ubytes_1 = __values(ubytes), ubytes_1_1 = ubytes_1.next(); !ubytes_1_1.done; ubytes_1_1 = ubytes_1.next()) {
                var n = ubytes_1_1.value;
                value = value * 256 + n;
                //value = (value << 8) | n;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (ubytes_1_1 && !ubytes_1_1.done && (_a = ubytes_1.return)) _a.call(ubytes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return value;
    };
    Bytes.syncIntToByteArray = function (int32) {
        /*
        const buffer = new ArrayBuffer(4);
        const int32View = new Int32Array(buffer);
        int32View[0] = int32;
        return new Int8Array(int32View.buffer, 0, 4);
        */
        var byteArray = [];
        for (var b = 0; b < 32; b += 8) {
            byteArray.push((int32 >>> (24 - (b % 32))) & 0xff);
        }
        return new Int8Array(byteArray);
    };
    Bytes.intFromByteArray = function (bytes) {
        return __awaiter(this, void 0, void 0, function () {
            var value, ubytes, ubytes_2, ubytes_2_1, n;
            var e_2, _a;
            return __generator(this, function (_b) {
                value = 0;
                ubytes = new Uint8Array(bytes);
                try {
                    for (ubytes_2 = __values(ubytes), ubytes_2_1 = ubytes_2.next(); !ubytes_2_1.done; ubytes_2_1 = ubytes_2.next()) {
                        n = ubytes_2_1.value;
                        value = value * 256 + n;
                        //value = (value << 8) | n;
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (ubytes_2_1 && !ubytes_2_1.done && (_a = ubytes_2.return)) _a.call(ubytes_2);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                return [2 /*return*/, value];
            });
        });
    };
    Bytes.longToByteArray = function (int64) {
        return __awaiter(this, void 0, void 0, function () {
            var byteArray, index, byte;
            return __generator(this, function (_a) {
                byteArray = [0, 0, 0, 0, 0, 0, 0, 0];
                for (index = 0; index < byteArray.length; index++) {
                    byte = int64 & 0xff;
                    byteArray[byteArray.length - index - 1] = byte;
                    int64 = (int64 - byte) / 256;
                    //int64 = int64 >> 8;
                }
                return [2 /*return*/, new Int8Array(byteArray)];
            });
        });
    };
    Bytes.longFromByteArray = function (bytes) {
        return __awaiter(this, void 0, void 0, function () {
            var value, ubytes, ubytes_3, ubytes_3_1, n, ubytes_4, ubytes_4_1, n;
            var e_3, _a, e_4, _b;
            return __generator(this, function (_c) {
                value = 0;
                ubytes = new Uint8Array(bytes);
                if (ubytes[0] >= 128) {
                    try {
                        for (ubytes_3 = __values(ubytes), ubytes_3_1 = ubytes_3.next(); !ubytes_3_1.done; ubytes_3_1 = ubytes_3.next()) {
                            n = ubytes_3_1.value;
                            value = value * 256 + (255 - n);
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (ubytes_3_1 && !ubytes_3_1.done && (_a = ubytes_3.return)) _a.call(ubytes_3);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    value += 1;
                    value *= -1;
                }
                else {
                    try {
                        for (ubytes_4 = __values(ubytes), ubytes_4_1 = ubytes_4.next(); !ubytes_4_1.done; ubytes_4_1 = ubytes_4.next()) {
                            n = ubytes_4_1.value;
                            value = value * 256 + n;
                            // value = (value << 8) | n;
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (ubytes_4_1 && !ubytes_4_1.done && (_b = ubytes_4.return)) _b.call(ubytes_4);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
                return [2 /*return*/, value];
            });
        });
    };
    Bytes.syncLongFromByteArray = function (bytes) {
        var e_5, _a;
        /*
        const a = new BigInt64Array(bytes.buffer);
        return Number(a[0]);
        */
        var value = 0;
        var ubytes = new Uint8Array(bytes);
        try {
            for (var ubytes_5 = __values(ubytes), ubytes_5_1 = ubytes_5.next(); !ubytes_5_1.done; ubytes_5_1 = ubytes_5.next()) {
                var n = ubytes_5_1.value;
                value = value * 256 + n;
                // value = (value << 8) | n;
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (ubytes_5_1 && !ubytes_5_1.done && (_a = ubytes_5.return)) _a.call(ubytes_5);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return value;
    };
    Bytes.floatToByteArray = function (float32) {
        return __awaiter(this, void 0, void 0, function () {
            var farr, buff, out, k, i;
            return __generator(this, function (_a) {
                farr = new Float32Array(1);
                farr[0] = float32;
                buff = new Int8Array(farr.buffer);
                out = [];
                k = 3;
                for (i = 0; i < 4; i += 1) {
                    out.push(buff[k]);
                    k--;
                }
                return [2 /*return*/, new Int8Array(out)];
            });
        });
    };
    Bytes.floatFromByteArray = function (bytes) {
        return __awaiter(this, void 0, void 0, function () {
            var bytesArray;
            return __generator(this, function (_a) {
                /*
                const a = new Float64Array(bytes.buffer);
                return a[0];
                */
                if (bytes.length === 4) {
                    bytesArray = new DataView(new Uint8Array(bytes).buffer);
                    return [2 /*return*/, bytesArray.getFloat32(0)];
                }
                else {
                    return [2 /*return*/, 0];
                }
                return [2 /*return*/];
            });
        });
    };
    Bytes.stringToByteArray = function (str) {
        return __awaiter(this, void 0, void 0, function () {
            var utf8, i, charcode;
            return __generator(this, function (_a) {
                utf8 = [];
                if (str !== undefined) {
                    for (i = 0; i < str.length; i++) {
                        charcode = str.charCodeAt(i);
                        if (charcode < 0x80)
                            utf8.push(charcode);
                        else if (charcode < 0x800) {
                            utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
                        }
                        else if (charcode < 0xd800 || charcode >= 0xe000) {
                            utf8.push(0xe0 | (charcode >> 12), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
                        }
                        // surrogate pair
                        else {
                            i++;
                            // UTF-16 encodes 0x10000-0x10FFFF by
                            // subtracting 0x10000 and splitting the
                            // 20 bits of 0x0-0xFFFFF into two halves
                            charcode = 0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
                            utf8.push(0xf0 | (charcode >> 18), 0x80 | ((charcode >> 12) & 0x3f), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
                        }
                    }
                }
                return [2 /*return*/, new Int8Array(utf8)];
            });
        });
    };
    Bytes.stringFromByteArray = function (bytes) {
        return __awaiter(this, void 0, void 0, function () {
            var decoder;
            return __generator(this, function (_a) {
                decoder = new StringDecoder('utf8');
                return [2 /*return*/, decoder.end(Buffer.from(bytes))];
            });
        });
    };
    Bytes.wordsToByteArray = function (wordArray) {
        var e_6, _a;
        if (wordArray.hasOwnProperty('sigBytes') && wordArray.hasOwnProperty('words')) {
            wordArray = wordArray.words;
        }
        var byteArray = [];
        try {
            for (var wordArray_1 = __values(wordArray), wordArray_1_1 = wordArray_1.next(); !wordArray_1_1.done; wordArray_1_1 = wordArray_1.next()) {
                var word = wordArray_1_1.value;
                for (var j = 3; j >= 0; --j) {
                    byteArray.push((word >> (8 * j)) & 0xff);
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (wordArray_1_1 && !wordArray_1_1.done && (_a = wordArray_1.return)) _a.call(wordArray_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return byteArray;
    };
    Bytes.prepareAfterDecrypt = function (byteArray) {
        for (var i = byteArray.length - 1; i >= 0; i--) {
            if (byteArray[i] === 125) {
                return byteArray.slice(0, ++i);
            }
        }
        return byteArray;
    };
    Bytes.convertUint8ArrayToWordArray = function (u8Array) {
        var words = [];
        var i = 0;
        var len = u8Array.length;
        while (i < len) {
            words.push((u8Array[i++] << 24) | (u8Array[i++] << 16) | (u8Array[i++] << 8) | u8Array[i++]);
        }
        return {
            sigBytes: words.length * 4,
            words: words,
        };
    };
    Bytes.syncStringToByteArray = function (str) {
        var utf8 = [];
        if (str !== undefined) {
            for (var i = 0; i < str.length; i++) {
                var charcode = str.charCodeAt(i);
                if (charcode < 0x80)
                    utf8.push(charcode);
                else if (charcode < 0x800) {
                    utf8.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
                }
                else if (charcode < 0xd800 || charcode >= 0xe000) {
                    utf8.push(0xe0 | (charcode >> 12), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
                }
                // surrogate pair
                else {
                    i++;
                    // UTF-16 encodes 0x10000-0x10FFFF by
                    // subtracting 0x10000 and splitting the
                    // 20 bits of 0x0-0xFFFFF into two halves
                    charcode = 0x10000 + (((charcode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
                    utf8.push(0xf0 | (charcode >> 18), 0x80 | ((charcode >> 12) & 0x3f), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
                }
            }
        }
        return new Int8Array(utf8);
    };
    Bytes.syncStringFromByteArray = function (bytes) {
        var decoder = new StringDecoder('utf8');
        return decoder.end(Buffer.from(bytes));
    };
    return Bytes;
}());
exports.Bytes = Bytes;
